import { Link, useNavigate } from 'react-router'
import { Button, Card, Icon, Stack, Text } from '@/design-system'
import { FlowLayout } from '@/app/layouts/FlowLayout'

const NEXT = [
  { icon: 'south_west', title: 'Add your first $50', body: 'It lands in your account and stays yours.', to: '/add-money' },
  { icon: 'north_east', title: 'Send money home', body: '1.0% to send, plus the corridor spread. Shown before you confirm.', to: '/transfers/send' },
  { icon: 'redeem', title: 'Start earning cashback', body: '0.5% on everything you buy, paid in cash on the 1st.', to: '/cashback' },
]

export function OnboardingReady() {
  const navigate = useNavigate()
  return (
    <FlowLayout
      step={3}
      totalSteps={3}
      back="/onboarding/card"
      footer={
        <Button size="lg" block iconEnd="arrow_forward" onClick={() => navigate('/')}>
          Go to my account
        </Button>
      }
    >
      <Stack gap={6}>
        <Stack gap={4} align="start">
          <Card tone="accent" padded={false} className="pb-ready-badge">
            <Icon name="check" size={24} />
          </Card>
          <Stack gap={2}>
            <Text as="h1" variant="title" weight="bold">
              You&rsquo;re set up
            </Text>
            <Text variant="body" tone="secondary">
              Your accounts are open and your card is on its way. Here is what most people do next.
            </Text>
          </Stack>
        </Stack>

        <Stack gap={3}>
          {NEXT.map((item) => (
            <Card key={item.title} tone="light" interactive as={Link} to={item.to}>
              <Stack direction="row" align="center" gap={4}>
                <Icon name={item.icon} size={20} />
                <Stack grow gap={0}>
                  <Text variant="caption" weight="semibold">
                    {item.title}
                  </Text>
                  <Text variant="eyebrow" tone="secondary">
                    {item.body}
                  </Text>
                </Stack>
                <Icon name="arrow_forward" size={16} />
              </Stack>
            </Card>
          ))}
        </Stack>
      </Stack>
    </FlowLayout>
  )
}
